<template>
  <component
    :is="component"
    class="segment">
      <slot></slot>
  </component>
</template>

<script>

export default {
  name: 'segment-elem',
  props: {
    'component': {
      type: String,
      default: 'div'
    }
  }
}
</script>

<style lang="sass">
.segment
</style>
